module.exports = __webpack_public_path__ + "static/media/Downarrow.59c528fc.svg";